import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IFormTemplateState } from './form-template.types';
import {
  IFormFieldData,
  IFormFieldOptionTodoData,
  IFormFieldOptionTodoTemplateData,
  IFormTemplateData
} from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IFormTemplateState = {
  version: 1,
  formTemplates: [] as IFormTemplateData[],
  formFields: [] as IFormFieldData[],
  formFieldOptionTodos: [] as IFormFieldOptionTodoData[],
  formTodoTempates: [] as IFormFieldOptionTodoTemplateData[]
};

const namespaced = true;

export const formTemplate: Module<IFormTemplateState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
